import { createFileRoute } from "@tanstack/react-router";

import QuestPromotion from "@/components/QuestProfile/QuestPromotion";

const Component = () => {
  const { questUuid } = Route.useParams();
  return <QuestPromotion questUuid={questUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion")(
  {
    component: Component,
  },
);
